<template>
  <div class="account-pages mt-5 mb-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <div class="card">
            <!-- Logo -->
            <div class="card-header pt-4 pb-4 text-center bg-primary">
              <a href="index.html">
                <span>
                  <img src="/images/logo-horizontal.svg" alt height="18" />
                </span>
              </a>
            </div>

            <div class="card-body p-4">
              <div class="text-center">
                <img src="/images/startman.svg" height="120" alt="File not found Image" />

                <h1 class="text-error mt-4">{{ statusCode }}</h1>
                <h4 class="text-uppercase text-danger mt-3">{{ error }}</h4>
                <!--<p class="text-muted mt-3">
                  <a href class="text-dark">
                    <b>Support</b>
                  </a>
                </p>
                -->
                <router-link :to="{ name: 'home' }" class="btn btn-info mt-3 text-decoration-none">
                  <i class="mdi mdi-reply"></i> Return Home
                </router-link>
              </div>
            </div>
            <!-- end card-body-->
          </div>
          <!-- end card-->
        </div>
        <!-- end col -->
      </div>
      <!-- end row -->
    </div>
    <!-- end container -->
  </div>
  <!-- end page -->
</template>

<script>
export default {
  props: {
    error: {
      type: [String, Number],
      default: 'Something went wrong'
    },
    statusCode: {
      type: [String, Number],
      default: 'Oops!'
    }
  }
}
</script>
